import { MenuItem, TextField, Select } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { valueByName } from './form_utils';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import Tooltip from '@mui/material/Tooltip';
import clsx from 'clsx';
const PREFIX = 'ECMultiSelectField';

const classes = {
  fixLabel: `${PREFIX}-fixLabel`,
};

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  [`& .${classes.fixLabel}`]: {
    transform: 'translate(14px, 12px) scale(1)',
  },
}));

export const ECMultiSelectField = props => {
  const { name, label, options, form, fid: fidProp, fname: fnameProp, defaultValue, initial, ...rest } = props;

  const fname =
    fnameProp ||
    (it => {
      return it.name;
    });
  const fid =
    fidProp ||
    (it => {
      return it.id;
    });

  const [value, setValue] = useState(valueByName(initial, name) || defaultValue || []);

  const inputRef = useRef(null);

  useEffect(() => {
    form.register(name);
    form.setValue(name, value);
  }, [form.register]);

  const handleChange = e => {
    form.setValue(name, e.target.value);
    setValue(e.target.value);
    form.clearErrors(name);
  };

  const valueString = () => {
    return options
      .filter(it => value.includes(fid(it)))
      .map(it => fname(it))
      .join(', ');
  };

  return (
    <StyledFormControl variant='outlined' fullWidth error={!!form.formState.errors[name]} style={{ marginTop: 8 }}>
      <InputLabel className={clsx(value.length === 0 && classes.fixLabel)}>{label}</InputLabel>
      <Tooltip title={valueString()}>
        <Select
          multiple
          value={value}
          onChange={handleChange}
          input={<OutlinedInput label={label} style={{ height: 40 }} />}
        >
          {options.map(it => (
            <MenuItem key={fid(it)} value={fid(it)}>
              {fname(it)}
            </MenuItem>
          ))}
        </Select>
      </Tooltip>
      {form.formState.errors[name] && <FormHelperText>{form.formState.errors[name].message}</FormHelperText>}
    </StyledFormControl>
  );
};

ECMultiSelectField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,

  options: PropTypes.array,
  fname: PropTypes.func,
  fid: PropTypes.func,

  form: PropTypes.object,

  defaultValue: PropTypes.any,
  initial: PropTypes.object,
};
